var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconStandardsLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconStandards",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M1694.176 1077.91c0 323.238-470.174 580.066-670.87 689.732-25.864 14.118-47.435 25.864-63.247 35.238-15.812-9.374-37.384-21.12-63.247-35.238-200.697-109.666-670.87-366.494-670.87-689.731V437.534L960.058 122.88l734.117 314.654v640.377ZM960.06 0 113 362.993v714.918c0 390.211 511.398 669.628 729.713 788.894 27.445 15.02 49.694 27.106 64.941 36.254v.113c16.15 9.713 34.221 14.57 52.405 14.57a100.79 100.79 0 0 0 52.405-14.683c15.247-9.148 37.496-21.233 64.94-36.254 218.316-119.266 729.714-398.683 729.714-788.894V362.993L960.058 0ZM604.69 868.563l-79.849 79.85 322.221 322.333 604.687-604.687-79.85-79.85-524.837 524.726L604.69 868.563Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconStandardsLine.glyphName = 'standards';
IconStandardsLine.variant = 'Line';
IconStandardsLine.displayName = 'IconStandardsLine';
IconStandardsLine.allowedProps = [...SVGIcon.allowedProps];
export default IconStandardsLine;
export { IconStandardsLine };